import { useContext } from 'react'
import { FieldValues } from 'react-hook-form'

import { SwitchProps } from 'components/Form/Switch'
import Paper from 'components/Paper'
import { InventoryAmazonUamTamSectionHeader } from 'features/globalSetup/features/amazon/components/InventoryAmazonUamTamSectionHeader'
import { useInventoryAmazonUamTamSwitchProps } from 'features/globalSetup/features/amazon/hooks/useInventoryAmazonUamTamSwitchProps'
import { cypressId } from 'features/inventory/ad-unit/forms/PrebidStackForm/utils'
import { AddEditDomainContext } from 'features/inventory/domain/contexts/AddEditDomainContext'
import { DomainPrebidStack } from 'features/inventory/domain/types/domainPrebidStack'
import { AdUnitAmazonAlerts } from './AdUnitAmazonAlerts'
import { useGetDomainAmazonAlerts } from './useGetDomainAmazons/useGetDomainAmazonAlerts'

export type Props = {
  amazonState: DomainPrebidStack['domainAmazonEnabled']
}

export const InventoryAmazonUamTamSection = <Schema extends FieldValues>({
  amazonState,
}: Props): JSX.Element => {
  const { domain } = useContext(AddEditDomainContext)

  if (domain === undefined) {
    throw Error('Domain should be accessible')
  }

  const switchProps: SwitchProps<Schema> = useInventoryAmazonUamTamSwitchProps<Schema>({
    amazonState,
    feature: 'domain',
  })

  const { alerts } = useGetDomainAmazonAlerts({ domainAmazonId: domain.domainAmazon.id })

  return (
    <Paper data-cy={cypressId('amazon-uam-tam')}>
      <InventoryAmazonUamTamSectionHeader
        Alerts={<AdUnitAmazonAlerts alerts={alerts} />}
        feature='domain'
        switchProps={switchProps}
      />
    </Paper>
  )
}
